/**
 * The poll cadence for everything on these screens that moves with the
 * daily valuation rather than by the minute: window aggregates (P&L, fees,
 * attribution), the period table's fixed windows, the performance series
 * and the transactions behind chart markers. The staging rate limiter is a
 * hard budget shared by every screen, and these fan out.
 */
export const SLOW_CADENCE_MS = 5 * 60 * 1000;
